export enum ECommercialOriginType {
  Undefined = 0,

  Organic = 1,

  SalesRepresentative = 2,

  Campaign = 3,

  Google = 4,

  Facebook = 5,

  Instagram = 6,

  TikTok = 7,

  YouTube = 8,

  WhatsApp = 9,

  Telegram = 10,

  LinkedIn = 11,

  Referral = 12,

  Marketplace = 13,

  EmailMarketing = 14,

  Reseller = 15,

  Other = 99,
}
